import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/templates",
        name: "templates",
        component: () => import("@/components/templates/_Templates.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewTemplatesUI,
            breadcrumbs: {
                icon: "templates-icon",
                paths: []
            },
            title: "navbar.templates"
        }
    },
    {
        path: "/templates/:templateId/update",
        name: "updatetemplate",
        component: () => import("@/components/templates/_TemplatesForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateTemplate,
            breadcrumbs: {
                icon: "templates-icon",
                paths: [
                    ["/templates", i18n.t("template.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/templates/create",
        name: "createtemplate",
        component: () => import("@/components/templates/_TemplatesForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateTemplate,
            breadcrumbs: {
                icon: "templates-icon",
                paths: [
                    ["/templates", i18n.t("template.title")]
                ]
            },
            title: "template.createnewtemplate"
        },
        props: true
    },
    {
        path: "/template/:templateId/preview",
        name: "templatepreview",
        component: () => import("@/components/templates/_TemplatePreview.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewTemplatesUI,
            layout: () => import("@/components/layouts/_BasicLayout.vue"),
            title: "common.preview"
        },
        props: true
    }
];
